import type {Values} from '@wix/devzai-utils-common';
import {enumGetValues, evaluateFunction} from '@wix/devzai-utils-common';
import type {DoppeBusinessEntityReference} from './doppe-business-entity';
import {DoppeBusinessEntity} from './doppe-business-entity';

export const DoppeExternalFormProvider = {
    Hopp: 'hopp',
} as const;

export type DoppeExternalFormProvider = Values<typeof DoppeExternalFormProvider>;

export const DoppeExternalFormField = {
    FormUrl: 'FormUrl',
} as const;

export type DoppeExternalFormField = Values<typeof DoppeExternalFormField>;

const AllExternalFormProviders = enumGetValues(DoppeExternalFormProvider);

const externalFormFieldsToSupportedProviders = {
    [DoppeExternalFormField.FormUrl]: AllExternalFormProviders,
} satisfies {
    [field in DoppeExternalFormField]: DoppeExternalFormProvider[]
}

export function doppeExternalFormProviderIsFieldProvided(
    externalFormProvider: DoppeExternalFormProvider | null | undefined,
    externalFormField: DoppeExternalFormField
) {
    if (externalFormProvider === null || externalFormProvider === undefined) {
        return false;
    }

    return externalFormFieldsToSupportedProviders[externalFormField].includes(externalFormProvider);
}

export function doppeExternalFormProviderResolveBusinessEntityReference(
    externalFormProvider: DoppeExternalFormProvider,
    externalFormId: string
) {
    return evaluateFunction(() => {
        switch (externalFormProvider) {
            case DoppeExternalFormProvider.Hopp: {
                return {
                    businessEntity: DoppeBusinessEntity.HoppForm,
                    id: externalFormId
                } as DoppeBusinessEntityReference<typeof DoppeBusinessEntity.HoppForm>
            }
        }
    }) satisfies DoppeBusinessEntityReference
}
